import { useContext } from 'react';
import { Icon, IconButton, Typography } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { ProductType } from '../application/models/NewJoinSessionData';
import { getProductPrice, eligibleForRV, eligibleForRVUpgrade } from '../utils/helpers';
import { AddOn } from '../components/AddOn';
import { ClubContentName, getClubContent } from '../utils/getClubContent';

export interface RVAddOnPros {
  setTooltipInfo: Function;
  setTooltipContent: Function;
  setDeleteInfo: Function;
  selectedRV: boolean;
  onUpgradeClick: () => void;
}

export const RVAddOn: (props: RVAddOnPros) => JSX.Element = ({
  setTooltipInfo,
  setTooltipContent,
  setDeleteInfo,
  selectedRV,
  onUpgradeClick,
}) => {
  const { membershipInfo, updateProducts, sessionData } = useContext(MembershipAppStateContext);

  if (!eligibleForRV(membershipInfo)) {
    return <></>;
  }

  const hasToUpgrade = eligibleForRVUpgrade(membershipInfo, sessionData);

  return (
    <>
      <div className="benefit-add-ons">
        <Typography className="benefit-add-ons-title add-rv-title" variant="b1Medium">
          Roadside for RV/motorcycle
        </Typography>
        <IconButton
          aria-label="RVs Trailers & Motorcycle info"
          className="add-RV-info-icon"
          onClick={() => {
            setTooltipInfo({
              tooltipTitle: 'Roadside for RV/motorcycle',
            });
            setTooltipContent(
              hasToUpgrade
                ? 'Optional roadside for RV/motorcycle is not available at the Classic benefit level.'
                : getClubContent(ClubContentName.RVToolTip, sessionData.clubCode!)
            );
          }}
        >
          <Icon iconName="circle-info-regular" sx={{ color: '#707070' }} />
        </IconButton>
      </div>
      {hasToUpgrade ? (
        <div className="rv-upgrade">
          <AddOn
            onAdd={onUpgradeClick}
            onDelete={() => {}}
            text="Upgrade to Plus or Premier"
            price={getProductPrice(membershipInfo, ProductType.RV, sessionData)}
            isSelected={selectedRV}
            icon="membership-card-solid"
            type={ProductType.RV}
            showPrice={false}
          />
        </div>
      ) : (
        <AddOn
          onAdd={() => updateProducts('add', ProductType.RV)}
          onDelete={() => {
            setDeleteInfo({
              title: 'Are you sure you want to remove roadside for RV/motorcycle?',
              confirmRemove: () => {
                updateProducts('remove', ProductType.RV);
              },
            });
          }}
          text="Add roadside for RV/motorcycle"
          price={getProductPrice(membershipInfo, ProductType.RV, sessionData)}
          isSelected={selectedRV}
          icon="van-shuttle-regular"
          type={ProductType.RV}
        />
      )}
    </>
  );
};
